import ZuiCard from '@zenbusiness/zui/Card';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';

const CardRoot = superstyled({
  name: 'CheckoutCard',
  slot: 'Root',
  tag: ZuiCard,
  propsAdded: {
    component: 'section',
    variant: 'elevation'
  },
  styles: ({ theme }) => ({
    borderRadius: theme.shape.rounded.xl,
    overflow: 'visible' // Prevent state field dropdown from being cut off
  })
});

function Card({ children, ...delegated }) {
  return (
    <CardRoot {...delegated}>
      <Stack p={2} spacing={2}>
        {children}
      </Stack>
    </CardRoot>
  );
}

export default Card;
